import React from 'react';
import palak from '../../assets/images/banner.png';
import { FaUserGraduate } from 'react-icons/fa';

const About = () => {
    return (
        <section>
            <div className="bg-secondary py-16">
                <div>
                    <h2 className="text-4xl text-accent font-bold text-center mb-4 lg:mb-0">
                        About Me
                    </h2>
                </div>
                <div className="py-10">
                    <div className="flex items-center justify-between flex-wrap px-4 lg:px-60 md:px-32">
                        <div className="w-full lg:w-2/4">
                            <img
                                data-aos="fade-right"
                                data-aos-duration="2000"
                                src={palak}
                                className="sm:max-w-sm mb-8 lg:mb-0"
                                alt="palak-sarker"
                            />
                        </div>
                        <div
                            data-aos="fade-left"
                            data-aos-duration="2000"
                            className="w-full lg:w-2/4"
                        >
                            <h1 className="leading-snug lg:text-5xl text-3xl font-bold">
                                Hi, I'm{' '}
                                <span className="text-accent leading-snug">
                                    Palak Sarker
                                </span>
                            </h1>
                            <h2 className="lg:text-3xl text-xl leading-normal mt-3">
                                A{' '}
                                <span className="text-accent leading-normal">
                                    self-taught
                                </span>{' '}
                                front-end web developer
                            </h2>
                            <p className="py-6 leading-8">
                                "Experienced Front-End Developer with a passion
                                for creating dynamic and visually appealing
                                websites. Proficient in HTML, CSS (Boostrap,
                                Tailwind CSS, DaisyUI), JavaScript, React,
                                Node.js, Express.js, and MongoDB. Aspiring to
                                full-stack development and building scalable
                                applications. Constantly exploring new
                                technologies and design trends to deliver
                                innovative and impactful solutions. Seeking new
                                challenges to further enhance my skills and
                                deliver exceptional results."
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* ==============education section start============== */}
            <div className="bg-primary">
                <div className="mt-10">
                    <div>
                        <h2 className="text-4xl text-accent font-bold text-center mb-10 lg:mb-0">
                            Education
                        </h2>
                    </div>
                    <span className="flex justify-center mt-10">
                        <FaUserGraduate size={40} />
                    </span>
                    <div className="mt-10 pb-10">
                        {/* ========education 1======== */}

                        <div
                            data-aos="fade-up"
                            data-aos-duration="2000"
                            className="grid grid-cols-9 items-baseline"
                        >
                            <div className="text-end col-span-4">
                                <small className="text-accent">
                                    Diploma in Engineering
                                </small>
                                <br />
                                <small>Tech: Telecommunication</small>
                                <br />
                                <small>2017 - 2021</small>
                                <br />
                                <small>GPA: 3.36 out of 4.00</small>
                            </div>
                            <div className="flex flex-col items-center col-span-1">
                                <span className="h-4 w-4 bg-white rounded-full"></span>
                                <span className="h-52 w-0.5 bg-white absolute"></span>
                            </div>
                            <div className="col-span-4"></div>
                        </div>

                        {/* ========education 2======== */}

                        <div
                            data-aos="fade-up"
                            data-aos-duration="2000"
                            className="grid grid-cols-9 items-baseline"
                        >
                            <div className="col-span-4"></div>
                            <div className="flex flex-col items-center col-span-1">
                                <span className="h-4 w-4 bg-white rounded-full"></span>
                                <span className="h-52 w-0.5 bg-white absolute"></span>
                            </div>
                            <div className="text-start col-span-4">
                                <small className="text-accent">
                                    Secondary School Certificate
                                </small>
                                <br />
                                <small>Technology: Science</small>
                                <br />
                                <small>2015 - 2017</small>
                                <br />
                                <small>GPA: 4.73 out of 5.00</small>
                            </div>
                        </div>

                        {/* ========education 3======== */}

                        <div
                            data-aos="fade-up"
                            data-aos-duration="2000"
                            className="grid grid-cols-9 items-baseline"
                        >
                            <div className="text-end col-span-4">
                                <small className="text-accent">
                                    Junior School Certificate
                                </small>
                                <br />
                                <small>Technology: General</small>
                                <br />
                                <small>2012 - 2014</small>
                                <br />
                                <small>GPA: 4.89 out of 5.00</small>
                            </div>
                            <div className="flex flex-col items-center col-span-1">
                                <span className="h-4 w-4 bg-white rounded-full"></span>
                                <span className="h-52 w-0.5 bg-white absolute"></span>
                            </div>
                            <div className="col-span-4"></div>
                        </div>

                        {/* ========education 4======== */}

                        <div
                            data-aos="fade-up"
                            data-aos-duration="2000"
                            className="grid grid-cols-9 items-baseline"
                        >
                            <div className="col-span-4"></div>
                            <div className="flex flex-col items-center col-span-1">
                                <span className="h-4 w-4 bg-white rounded-full"></span>
                                <span className="h-52 lg:h-auto  w-0.5 bg-white absolute"></span>
                            </div>
                            <div className="text-start col-span-4">
                                <small className="text-accent">
                                    Primary School Certificate
                                </small>
                                <br />
                                <small>Technology: General</small>
                                <br />
                                <small>2006 - 2011</small>
                                <br />
                                <small>GPA: 5.00 out of 5.00</small>
                            </div>
                        </div>
                        <div className="flex flex-col items-center mt-2">
                            <span className="h-4 w-4 bg-white rounded-full"></span>
                        </div>
                    </div>
                </div>
            </div>
            {/* ==============education section end============== */}
        </section>
    );
};

export default About;
